export default Object.freeze(
    {
        DEBUG_MODE: ['true', '1', 'on'].includes(import.meta.env.VITE_DEBUG_MODE),
    }
);
